<div class="flex-content">
  <div class="content col-sm container-fluid">

    <div *ngFor="let data of pubs$ | async" class="row list">
      <!--<h2 class="year-title" [id]='id' >{{id}}</h2>-->
      <div class="col-sm-12 year display-4" [id]='data[0].year'>
        {{data[0].year}}
      </div>

      <!-- <a *ngIf="pubs[0].dateset" target="_blank" download type="application/octet-stream" [href]='imgPath +pubs[0].dataset' target="_blank">/ Dataset <mat-icon class="material-icons">file_download</mat-icon></a>   -->

      <div *ngFor="let publication of data" class="data-box">
        <a target="_blank" download type="application/octet-stream" [href]='imgPath +publication.paper' target="_blank" class="data-img">
          <img default="./../../../../assets/Contents/imgs/no_image.jpg" [srcset]='imgPath + publication.img + " 800w, " +
                        imgPath+ publication.smallImg + " 300w "' sizes="(min-width:990px) 300px, 800px">

        </a>
        <div class="data-desc">
          <a target="_blank" download type="application/octet-stream" [href]='imgPath +publication.paper' target="_blank" class="h3">{{publication.title}}</a>
          <div class="people_name">
            <a [routerLink]='["/main/people/person", author.id]' *ngFor="let author of publication.authors; let isLast=last" >
              {{author.name}}{{isLast ? '' : ', '}}
            </a>
          </div>
          <p *ngIf="publication.conference" class="menu01">Conference: {{publication.conference}}</p>
          <p *ngIf="publication.journal" class="menu01">Journal: {{publication.journal}}</p>
        </div>
      </div>

      <hr/>

    </div>
    <div class="pagination d-flex justify-content-center">
      <button (click)="navigateToPage(currentPage - 1)" [disabled]="currentPage === 1">Previous</button>
      <span *ngFor="let page of getPageNumbers()">
        <button (click)="navigateToPage(page)" [class.active]="currentPage === page">{{page}}</button>
      </span>
      <button (click)="navigateToPage(currentPage + 1)" [disabled]="currentPage === totalPages">Next</button>
    </div>
    <br>
    <br>
  </div>
</div>



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/research-publicate-kr/research-publicate-kr.component.html